import { connect } from 'react-redux'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import Navigation from 'support/navigation'
import i18n from 'support/i18n'

const mapStateToProps = (state) => ({
  title: i18n.t('CONFIRMATION_MESSAGE'),
  description: i18n.t('EXPLORE_IDEA.IDEA_DISCARDED'),
  mainButtonText: i18n.t('ACCEPT'),
  customIdeaTitles: state.data.domain.customTitlesConf.customIdeaTitles
})

const mapDispatchToProps = (dispatch) => {
  return {
    mainButtonAction: () => {
      dispatch(hideDialog())
      dispatch(Navigation.navigateToExplore())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
